import React from 'react';

import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Text } from '@rtkwlf/fenrir-react';
import { faAngleRight } from '@rtkwlf/pro-regular-svg-icons/faAngleRight';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { TICKET_DETAILS_ROUTE } from 'ae-constants/routes.constants';

type ViewTicketLinkProps = { ticketId: string; showLabel?: boolean };

export const ViewTicketLink: React.FC<ViewTicketLinkProps> = ({
  ticketId,
  showLabel,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleViewTicket = () => {
    const url = generatePath(TICKET_DETAILS_ROUTE, { ticketId });
    navigate(url);
  };

  return showLabel ? (
    <Button
      variant="link"
      onClick={handleViewTicket}
      iconRight={<FontAwesomeIcon icon={faAngleRight} />}
      css={css({
        top: '-6px',
      })}
    >
      {t('ticket:viewTicket')}
    </Button>
  ) : (
    <Text
      styledAs="body3"
      textColor="brandDefault"
      cursor="pointer"
      textDecoration="underline"
      whiteSpace="nowrap"
      onClick={handleViewTicket}
    >
      {ticketId}
    </Text>
  );
};
